(function () {
  var page = document.querySelector("[data-ennead-page]");
  if (!page) return;

  var detailRoot = page.closest("[data-sahael-bloodline-detail]");
  if (!detailRoot) return;

  var assetBase = page.getAttribute("data-asset-base") || "";
  var leftRail = page.querySelector("[data-ennead-portraits-left]");
  var rightRail = page.querySelector("[data-ennead-portraits-right]");
  var loreTarget = page.querySelector("[data-ennead-lore]");
  var treeTarget = page.querySelector("[data-ennead-tree]");
  var abilityTarget = page.querySelector("[data-ennead-abilities]");
  var recordSlot = page.querySelector("[data-ennead-record-slot]");

  function element(tagName, className, text) {
    var node = document.createElement(tagName);
    if (className) node.className = className;
    if (text !== undefined) node.textContent = text;
    return node;
  }

  function makePortrait(imageAsset) {
    var frame = element("span", "ennead-page-portrait");
    var image = element("img");
    image.src = assetBase + imageAsset;
    image.alt = "";
    image.loading = "lazy";
    image.decoding = "async";
    image.onerror = function () {
      image.remove();
    };
    frame.appendChild(image);
    return frame;
  }

  function renderPortraitRail(target, commanders) {
    target.replaceChildren();
    commanders.forEach(function (commander) {
      var figure = element("figure", "ennead-page-portrait-card");
      figure.appendChild(makePortrait(commander.imageAsset));
      var caption = element("figcaption");
      caption.appendChild(element("span", "", commander.ordinal + " Legion"));
      caption.appendChild(element("strong", "", commander.name));
      figure.appendChild(caption);
      target.appendChild(figure);
    });
  }

  function addRecordSection(container, title, text) {
    var section = element("section", "ennead-record-section");
    section.appendChild(element("h3", "", title));
    section.appendChild(element("p", "", text));
    container.appendChild(section);
  }

  function openRecord(title, role, imageAsset, sections, trigger) {
    recordSlot.replaceChildren();

    var overlay = element("div", "ennead-record-overlay");
    overlay.setAttribute("data-ennead-record-overlay", "");
    var dialog = element("div", "ennead-record-dialog");
    dialog.setAttribute("role", "dialog");
    dialog.setAttribute("aria-modal", "true");
    dialog.setAttribute("aria-labelledby", "ennead-record-title");
    dialog.tabIndex = -1;

    var topline = element("div", "ennead-record-topline");
    topline.appendChild(element("span", "", "SAHAEL · ENNEAD RECORD"));
    var close = element("button", "ennead-record-close", "Close");
    close.type = "button";
    close.setAttribute("data-ennead-record-close", "");
    close.setAttribute("aria-label", "Close commander record");
    topline.appendChild(close);
    dialog.appendChild(topline);

    var heading = element("div", "ennead-record-heading");
    if (imageAsset) {
      heading.appendChild(makePortrait(imageAsset));
    } else {
      heading.appendChild(element("span", "ennead-page-placeholder"));
    }
    var headingCopy = element("div");
    headingCopy.appendChild(element("p", "ennead-page-role", role));
    var titleNode = element("h2", "", title);
    titleNode.id = "ennead-record-title";
    headingCopy.appendChild(titleNode);
    heading.appendChild(headingCopy);
    dialog.appendChild(heading);

    var sectionList = element("div", "ennead-record-sections");
    sections.forEach(function (section) {
      addRecordSection(sectionList, section.title, section.text);
    });
    dialog.appendChild(sectionList);
    overlay.appendChild(dialog);
    recordSlot.appendChild(overlay);

    function closeRecord() {
      recordSlot.replaceChildren();
      document.removeEventListener("keydown", onKeydown);
      if (trigger && document.contains(trigger)) trigger.focus();
    }

    function onKeydown(event) {
      if (event.key === "Escape") {
        event.preventDefault();
        closeRecord();
        return;
      }
      if (event.key !== "Tab") return;
      var focusable = Array.prototype.slice.call(
        dialog.querySelectorAll('button:not([disabled]), a[href], [tabindex]:not([tabindex="-1"])'),
      );
      if (!focusable.length) return;
      var first = focusable[0];
      var last = focusable[focusable.length - 1];
      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    }

    close.addEventListener("click", closeRecord);
    overlay.addEventListener("mousedown", function (event) {
      if (event.target === overlay) closeRecord();
    });
    document.addEventListener("keydown", onKeydown);
    close.focus();
  }

  function commanderSections(commander) {
    return [
      { title: "Who he is", text: commander.whoHeIs },
      { title: "Weapon set", text: commander.weaponSet },
      { title: "Ring or Rings", text: commander.rings },
      { title: "In the books", text: commander.inBooks },
      { title: "Bloodline abilities", text: commander.abilities.join(", ") },
    ];
  }

  function renderCommanderButton(commander, isChief) {
    var button = element(
      "button",
      isChief ? "ennead-page-chief-button" : "ennead-page-commander",
    );
    button.type = "button";
    button.setAttribute("data-commander-id", commander.id);
    button.setAttribute("aria-haspopup", "dialog");
    button.setAttribute(
      "aria-label",
      "Read " + commander.name + (isChief ? ", Commander in Chief" : ", " + commander.ordinal + " Legion commander"),
    );
    if (!isChief) {
      button.appendChild(element("span", "ennead-page-number", String(commander.legionNumber)));
    }
    button.appendChild(makePortrait(commander.imageAsset));
    button.appendChild(element("span", "ennead-page-role", isChief ? "Commander in Chief" : commander.ordinal + " Legion"));
    button.appendChild(element("span", "ennead-page-person-name", commander.name));
    button.appendChild(element("span", "ennead-page-open-note", "Read commander record"));
    button.addEventListener("click", function () {
      openRecord(
        commander.name,
        isChief ? "Commander in Chief" : commander.ordinal + " Legion",
        commander.imageAsset,
        commanderSections(commander),
        button,
      );
    });
    return button;
  }

  function renderTree(data) {
    var commanders = data.commanders
      .filter(function (commander) { return commander.legionNumber > 0; })
      .sort(function (first, second) { return first.legionNumber - second.legionNumber; });
    var chief = data.commanders.find(function (commander) { return commander.id === "atum"; });
    if (!chief) throw new Error("The Ennead Commander in Chief is missing.");

    treeTarget.replaceChildren();
    var chiefCard = element("div", "ennead-page-chief");
    chiefCard.appendChild(renderCommanderButton(chief, true));
    treeTarget.appendChild(chiefCard);
    treeTarget.appendChild(element("div", "ennead-page-root-line"));
    treeTarget.appendChild(element("div", "ennead-page-branch-line"));

    var commanderGrid = element("div", "ennead-page-commander-grid");
    commanderGrid.setAttribute("aria-label", "Nine Ennead commanders");
    commanders.forEach(function (commander) {
      commanderGrid.appendChild(renderCommanderButton(commander, false));
    });
    treeTarget.appendChild(commanderGrid);
    treeTarget.appendChild(element("div", "ennead-page-zero-line"));

    var zero = data.zeroLegion;
    if (!zero) throw new Error("The Zero Legion record is missing.");
    var zeroButton = element("button", "ennead-page-zero");
    zeroButton.type = "button";
    zeroButton.setAttribute("data-zero-legion", "");
    zeroButton.setAttribute("aria-haspopup", "dialog");
    zeroButton.setAttribute("aria-label", "Read the Zero Legionnaires connection to Commander in Chief Atum");
    zeroButton.appendChild(element("span", "ennead-page-number", String(zero.number)));
    zeroButton.appendChild(element("span", "ennead-page-placeholder"));
    zeroButton.appendChild(element("span", "ennead-page-role", "Zero Legion"));
    zeroButton.appendChild(element("span", "ennead-page-person-name", zero.name));
    zeroButton.appendChild(element("span", "ennead-page-open-note", zero.guardianDescription));
    zeroButton.addEventListener("click", function () {
      openRecord(
        zero.name,
        "Zero Legion",
        "",
        [
          { title: "Connection", text: zero.connection },
          { title: "Guardian description", text: zero.guardianDescription },
        ],
        zeroButton,
      );
    });
    treeTarget.appendChild(zeroButton);
  }

  function createAbilityIcon() {
    var svg = document.createElementNS("http://www.w3.org/2000/svg", "svg");
    svg.setAttribute("viewBox", "0 0 24 24");
    svg.setAttribute("fill", "none");
    svg.setAttribute("stroke", "currentColor");
    svg.setAttribute("stroke-width", "1.3");
    svg.setAttribute("stroke-linecap", "round");
    svg.setAttribute("stroke-linejoin", "round");
    svg.setAttribute("aria-hidden", "true");
    svg.classList.add("ennead-page-ability-icon");
    var path = document.createElementNS("http://www.w3.org/2000/svg", "path");
    path.setAttribute("d", "M12 22s8-4 8-11V5l-8-3-8 3v6c0 7 8 11 8 11z");
    svg.appendChild(path);
    return svg;
  }

  function createAbilityArtwork(ability, size, variant) {
    var frame = element("span", "sahael-ability-emblem sahael-ability-emblem--" + variant);
    if (variant === "card") frame.classList.add("ennead-page-ability-icon");
    frame.setAttribute("aria-hidden", "true");

    var image = element("img", "sahael-ability-emblem__image");
    image.src = assetBase + "ennead-" + ability.slug + "-" + size + ".webp";
    image.alt = "";
    image.width = size;
    image.height = size;
    image.loading = variant === "card" ? "lazy" : "eager";
    image.decoding = "async";
    image.onerror = function () {
      console.error("Unable to load Ennead ability artwork: " + image.src);
      frame.replaceChildren(createAbilityIcon());
    };
    frame.appendChild(image);
    return frame;
  }

  function addAbilityModalTemplate(data, index) {
    var template = document.createElement("template");
    template.setAttribute("data-ability-modal", String(index));

    var overlay = element("div", "fixed inset-0 z-50 flex items-center justify-center bg-black/80 backdrop-blur-sm p-4");
    overlay.setAttribute("data-testid", "ability-modal-overlay");
    var dialog = element("div", "relative max-w-2xl w-full max-h-[90vh] overflow-y-auto rounded-lg border p-8");
    dialog.setAttribute("data-testid", "ability-modal");
    dialog.setAttribute("role", "dialog");
    dialog.setAttribute("aria-modal", "true");
    dialog.setAttribute("aria-labelledby", "ennead-ability-title-" + index);

    var close = element("button", "absolute top-4 right-4 text-muted-foreground hover:text-foreground", "Close");
    close.type = "button";
    close.setAttribute("data-ability-close", "");
    close.setAttribute("aria-label", "Close ability details");
    dialog.appendChild(close);

    var heading = element("div", "flex flex-col sm:flex-row items-start sm:items-center gap-4 mb-6 pr-4");
    var iconFrame = createAbilityArtwork(data, 512, "panel");
    heading.appendChild(iconFrame);
    var headingCopy = element("div");
    var title = element("h3", "font-mythic text-2xl md:text-3xl tracking-wide bloodline-identity-heading", data.name);
    title.id = "ennead-ability-title-" + index;
    headingCopy.appendChild(title);
    headingCopy.appendChild(element("p", "text-sm uppercase tracking-wider bloodline-identity-heading", "ENNEAD BLOODLINE ABILITY"));
    heading.appendChild(headingCopy);
    dialog.appendChild(heading);

    var detailList = element("div", "space-y-6");
    [
      ["Description", data.details.description],
      ["Mastery", data.details.mastery],
      ["Manifestation", data.details.manifestation],
    ].forEach(function (detail) {
      var section = element("section");
      section.appendChild(element("h4", "font-mythic text-lg tracking-wide mb-2 text-foreground", detail[0]));
      section.appendChild(element("p", "leading-relaxed text-foreground/95", detail[1]));
      detailList.appendChild(section);
    });
    if (data.details.teaser) {
      var teaser = element("section");
      teaser.appendChild(element("h4", "font-mythic text-lg tracking-wide mb-2 text-foreground", "Teaser"));
      teaser.appendChild(element("p", "leading-relaxed text-foreground/95", data.details.teaser));
      detailList.insertBefore(teaser, detailList.children[1] || null);
    }
    dialog.appendChild(detailList);
    var closeRow = element("div", "mt-8 text-center");
    var closeButton = element("button", "rounded-md border px-4 py-2 text-sm", "Close");
    closeButton.type = "button";
    closeButton.setAttribute("data-ability-close", "");
    closeRow.appendChild(closeButton);
    dialog.appendChild(closeRow);
    overlay.appendChild(dialog);
    template.content.appendChild(overlay);
    detailRoot.appendChild(template);
  }

  function renderAbilities(abilities) {
    abilityTarget.replaceChildren();
    abilities.forEach(function (ability, index) {
      var button = element("button", "ennead-page-ability");
      button.type = "button";
      button.setAttribute("data-ability-open", String(index));
      button.setAttribute("aria-haspopup", "dialog");
      button.setAttribute("aria-label", "Read about " + ability.name);
      button.appendChild(createAbilityArtwork(ability, 256, "card"));
      button.appendChild(element("span", "ennead-page-ability-name", ability.name));
      button.appendChild(element("span", "ennead-page-ability-hint", "Tap to view power"));
      abilityTarget.appendChild(button);
      addAbilityModalTemplate(ability, index);
    });
  }

  function render(data) {
    if (!data || !data.bloodline || !Array.isArray(data.commanders) || !Array.isArray(data.abilities)) {
      throw new Error("The Ennead page data is incomplete.");
    }

    loreTarget.replaceChildren();
    data.bloodline.lore.split(/\n{2,}/).forEach(function (paragraph) {
      loreTarget.appendChild(element("p", "", paragraph));
    });

    var portraits = data.commanders
      .filter(function (commander) { return commander.legionNumber > 0; })
      .sort(function (first, second) { return first.legionNumber - second.legionNumber; });
    renderPortraitRail(leftRail, portraits.filter(function (_commander, index) { return index % 2 === 0; }));
    renderPortraitRail(rightRail, portraits.filter(function (_commander, index) { return index % 2 === 1; }));
    renderTree(data);
    renderAbilities(data.abilities);
  }

  fetch(page.getAttribute("data-canon-url"), { cache: "no-cache" })
    .then(function (response) {
      if (!response.ok) throw new Error("The Ennead page data request failed.");
      return response.json();
    })
    .then(render)
    .catch(function (error) {
      console.error("Ennead page could not be rendered.", error);
      [loreTarget, treeTarget, abilityTarget].forEach(function (target) {
        target.replaceChildren(element("p", "", "Ennead information could not be loaded."));
      });
    });
})();
